import api from '../service/api'
import { responseBuild } from "./utils";

const service = api;

export const postInsertarExperienciaProfesional = async (data) => {
    await service.setToken();
    let request = await service.post(`/perfilcandidato/insertar-experiencia-profesional`, data).then(responseBuild);
    if (request) {
        return request
    }
    return {}
}

export const postInsertarFormacion = async (data) => {
    await service.setToken();
    let request = await service.post(`/candidatos/formacion-cadidato`, data).then(responseBuild);
    if (request) {
        return request
    }
    return {}
}

export const postInsertarPreferencias = async (data) => {
    await service.setToken();
    let request = await service.post(`/perfilcandidato/insertar-preferencias`, data).then(responseBuild);
    if (request) {
        return request
    }
    return {}
}

export const postInsertarConocimiento = async (data) => {
    await service.setToken();
    let request = await service.post(`/perfilcandidato/insertar-conocimiento`, data).then(responseBuild);
    if (request) {
        return request
    }
    return {}
}

export const postInsertarIdioma = async (data) => {
    await service.setToken();
    let request = await service.post(`/perfilcandidato/insertar-idioma`, data).then(responseBuild);
    if (request) {
        return request
    }
    return {}
}